"use client";

import { useEffect, useRef } from "react";

export const useScrollToSelectedSport = <T extends { id?: number; sport_id?: number }>(
    activeSportId: number | null,
    sports: T[],
    indexOffset = 0,
) => {
    const containerRef = useRef<HTMLDivElement>(null);

    const selectedSportIndex = activeSportId
        ? sports.findIndex((sport) => (sport.id || sport.sport_id) === activeSportId)
        : -1;

    // scroll to selected sport only once, on mount
    useEffect(() => {
        if (selectedSportIndex >= 0) {
            const container = containerRef.current;
            const targetEl = container?.children[selectedSportIndex + indexOffset] as
                | HTMLElement
                | undefined;

            if (container && targetEl) {
                container.scrollTo({ left: targetEl.offsetLeft });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        containerRef,
        selectedSportIndex,
    };
};
